<template>
  <router-view v-if="!loading"/>
  <div v-else style="height: 100vh;background-color: #EEF5FB" v-loading="loading"
       :element-loading-text="loadingText" element-loading-background="transparent"></div>
</template>

<script>
import {mapStores} from "pinia";
import {useCompanyStore} from "@/stores/company";
import {useUserStore} from "@/stores/user";


export default {

  computed: {
    ...mapStores(useCompanyStore, useUserStore)
  },
  data() {
    return {
      loadingText: 'Nocode Loading...',
      loading: false,
      companyChannel: null,
    }
  },
  async created() {

    // 判断是否为移动端设备（包括微信浏览器）
    let isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    let isWechat = /MicroMessenger/i.test(navigator.userAgent);
    let isPC = !isMobile;

    if (isPC) {
      this.loading = true;
      await this.userStore.initUser();
      if (this.userStore.token) {
        await this.companyStore.init();
        // 监听其他标签页的公司切换广播
        this.companyChannel = new BroadcastChannel('nocode_company_sync')
        this.companyChannel.onmessage = (event) => {
          const { type, company_id, userData, token } = event.data
          if (type === 'COMPANY_SWITCHED' && this.userStore.getCompanySelected !== company_id) {
            this.$alert(
              `检测到在其他标签页切换了公司/组织，当前页面可能无法继续访问，即将回到首页`,
              '提示',
              { confirmButtonText: '确定', type: 'warning',showClose: false }
            ).then(() => {
              if (userData) {
                this.userStore.setUser(userData)
              }
              location.href = '/'
            })
          } else if (type === 'USER_RELOGINED') {
            this.$alert(
              `检测到在其他标签页重新登录了账号，当前页面即将回到首页`,
              '提示',
              { confirmButtonText: '确定', type: 'warning', showClose: false }
            ).then(() => {
              if (userData) this.userStore.setUser(userData)
              if (token) this.userStore.setToken(token)
              location.href = '/'
            })
          }
        }
      }
      window.addEventListener('keydown', this.handleKeydown);
      this.loading = false;
    } else {
      let currentUrl = window.location.href;
      let newUrl = currentUrl.replace(/https?:\/\/[^\/]+/, 'http://nocode-mini.gridssoft.com');

      // 确保在微信中也能够跳转
      if (isWechat) {
        // 微信浏览器中使用 location.replace 更可靠
        window.location.replace(newUrl);
      } else {
        window.location.href = newUrl;
      }
    }
  },
  methods: {
    handleKeydown(event) {
      // 检查是否按下 Backspace 键
      if (event.key === 'Backspace') {
        // 获取事件的目标元素
        const target = event.target;

        // 判断目标元素是否为输入框、textarea 或 contenteditable 元素
        const isInput = target.tagName === 'INPUT';
        const isTextarea = target.tagName === 'TEXTAREA';
        const isContentEditable = target.getAttribute('contenteditable') === 'true';

        // 如果不是上述元素之一，则阻止默认行为
        if (!(isInput || isTextarea || isContentEditable)) {
          event.preventDefault();
        }
      }

// 防止回车键导致页面链接变化
      if (event.key === 'Enter') {
        // 获取事件的目标元素
        const target = event.target;

        // 判断目标元素是否为输入框、textarea 或可提交的表单元素
        const isInput = target.tagName === 'INPUT';
        const isTextarea = target.tagName === 'TEXTAREA';
        const isButton = target.tagName === 'BUTTON';
        const isLink = target.tagName === 'A' || target.closest('a');

        // 如果不是表单提交元素，则阻止事件冒泡
        if (!(isInput || isTextarea || isButton || isLink)) {
          event.stopPropagation();
        }
      }
    }
  },
  beforeUnmount() {
    if (this.companyChannel) {
      this.companyChannel.close()
    }
  }
}


</script>

<style>

#app {
  font-size: 12px;
}

.el-popover {
  --el-popover-border-radius: 10px !important;
}
.el-icon-loading {
  color: mediumvioletred;
}

.mx-context-menu-item .label {
  cursor: default;
  margin-left: 4px;
}


.el-scrollbar {
  .el-scrollbar__bar.is-horizontal {
    height: 10px;
  }

  .el-scrollbar__bar.is-horizontal .el-scrollbar__thumb {
    background: #171515;
    cursor: default;
    height: 6px;
  }
}


i {
  font-size: 14px;
}

.el-table .cell {
  font-size: 13px !important;
}

/** remove qq.map log */
a .csssprite {
  display: none;
}

div[draggable="false"][onresize="return;"] {
  display: none;
}

/** remove ckEditor log */
div .ck-powered-by {
  display: none;
}

.el-drawer__header {
  margin-bottom: 0 !important;
}

.el-drawer__title {
  color: #344262;
}


.el-divider--horizontal {
  margin: 10px 0 20px 0;
}

.danger {
  color: #F56C6C;
}

.el-form-item__label {
  width: 100%;
}

.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}

</style>
